import styled from '@emotion/styled';

export const Row = styled.div`
  display: flex;
  gap: 0 32px;
`;
